import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem, size } from 'polished'

export const helperTextAlertIcon = (theme: Theme): SerializedStyles =>
  css({
    fill: theme.palette.error.main,
    marginRight: theme.spacing(1),
    minWidth: rem(16),
    ...size(rem(16)),
  })

export const helperTextMessage = (theme: Theme): SerializedStyles =>
  css({
    color: theme.palette.error.main,
    display: 'flex',
    fill: theme.palette.error.main,
    margin: theme.spacing(0, '0'),
    paddingLeft: 0,
  })
